import { useMemo } from 'react';
import { Link } from '@tanstack/react-router';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { EntityTable } from '@/components/table/entity-table';
import { CoachOverallGradeBadge } from '@/components/coaches/coach-overall-grade-badge';
import { sortByOverallGrade } from '@/lib/coach-utils';
import { EligibleCoachForClassTime } from '@airreading/common/data';

const columnHelper = createColumnHelper<EligibleCoachForClassTime>();

const scheduledClassesTableColumns = [
  columnHelper.accessor('fullNameOrEmail', {
    id: 'fullNameOrEmail',
    header: 'Name',
    cell: ({ getValue, row }) => {
      return (
        <Link to={'/teachers/$teacherId'} params={{ teacherId: row.original.id }} className="text-blue-600">
          {getValue()}
        </Link>
      );
    },
  }),

  columnHelper.accessor('overallGrade', {
    id: 'overallGrade',
    header: 'Overall grade',
    cell: ({ getValue }) => {
      const overallGrade = getValue();
      return <CoachOverallGradeBadge grade={overallGrade} />;
    },
  }),
];

export const ClassTimesEligibleCoachesTable = ({
  eligibleCoaches,
}: {
  eligibleCoaches: EligibleCoachForClassTime[];
}) => {
  const sortedCoaches = useMemo(() => sortByOverallGrade(eligibleCoaches), [eligibleCoaches]);

  const table = useReactTable({
    data: sortedCoaches,
    columns: scheduledClassesTableColumns,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
    enableSorting: false,
  });

  return (
    <div className="max-h-[400px] overflow-y-auto">
      <EntityTable
        table={table}
        isLoading={false}
        hasError={false}
        emptyState="No scheduled classes found"
        errorState={null}
        emptyStateClassName="translate-y-0"
      />
    </div>
  );
};
